/**
 * Gets both text direction and alignment for a text string in a single check
 * @param text - The text to check
 * @returns An object with 'direction' ('rtl' | 'ltr') and 'alignment' ('left' | 'right')
 */
export function getTextDirectionAndAlignment(text: string | null | undefined): {
  direction: 'rtl' | 'ltr';
  textAlign: 'left' | 'right';
} {
  if (!text || typeof text !== 'string') {
    return {
      direction: 'ltr',
      textAlign: 'left'
    };
  }

  // RTL Unicode ranges:
  // Hebrew: \u0590-\u05FF
  // Arabic: \u0600-\u06FF
  // Persian/Farsi: \u06A0-\u06FF (overlaps with Arabic)
  // Urdu: Uses Arabic script
  // Other RTL scripts: \u0700-\u074F (Syriac), \u0750-\u077F (Arabic Supplement)
  // etc.
  
  const rtlPattern = /[\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  const isRtl = rtlPattern.test(text);
  
  return {
    direction: isRtl ? 'rtl' : 'ltr',
    textAlign: isRtl ? 'right' : 'left'
  };
}

